'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Slider", {
    enumerable: true,
    get: function() {
        return Slider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useSlider = require("./useSlider");
const _renderSlider = require("./renderSlider");
const _useSliderStylesstyles = require("./useSliderStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Slider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSlider.useSlider_unstable)(props, ref);
    (0, _useSliderStylesstyles.useSliderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useSliderStyles_unstable')(state);
    return (0, _renderSlider.renderSlider_unstable)(state);
});
Slider.displayName = 'Slider';
